import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { applyTheme, getStoredTheme } from "../theme";

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getStoredTheme);
  const next = theme === "dark" ? "light" : "dark";

  const toggle = () => {
    applyTheme(next);
    setTheme(next);
  };

  return (
    <Button variant="outline-secondary" size="sm" onClick={toggle} title={`Switch to ${next} mode`}>
      {theme === "dark" ? "☀ Light mode" : "☾ Dark mode"}
    </Button>
  );
}
